import { AlertTriangle, XCircle } from "lucide-react";
import { sisaHariSertifikat, statusSertifikat } from "@/lib/sertifikat";

const fmtTgl = (d) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || "")); return m ? `${m[3]}/${m[2]}/${m[1]}` : "-"; };

export default function SertifikatBerlakuBadge({ dok, compact = false }) {
  const st = statusSertifikat(dok);
  if (!st) return null;
  const sisa = sisaHariSertifikat(dok);
  const cls = st === "habis" ? "bg-rose-600 text-white border-rose-600" : st === "segera" ? "bg-rose-100 text-rose-700 border-rose-300" : "bg-emerald-50 text-emerald-700 border-emerald-200";
  const label = st === "habis" ? `Kadaluarsa ${fmtTgl(dok.berlaku_sampai)}` : st === "segera" ? `${sisa} hari lagi` : `s/d ${fmtTgl(dok.berlaku_sampai)}`;
  return (
    <span title={`Berlaku sampai ${fmtTgl(dok.berlaku_sampai)}`} data-testid={`sertifikat-berlaku-${dok.id}`}
      className={`inline-flex shrink-0 items-center gap-1 rounded-full border font-bold ${compact ? "px-1.5 text-[9px]" : "px-2 py-0.5 text-[10px]"} ${cls}`}>
      {st === "habis" ? <XCircle className="h-3 w-3" /> : st === "segera" ? <AlertTriangle className="h-3 w-3" /> : null}{label}
    </span>
  );
}
